// @flow
import CreateServiceCheckInModalContainer from './CreateServiceCheckInModalContainer';

export default CreateServiceCheckInModalContainer;
